<p-toast></p-toast>
<div class="list-products-page page-wrapper" #containerCategories>
  <div class="wrap-breadcrumb">
    <div class="container">
      <div class="breadcrumb">
        <div *ngIf="checkRouterCategories">
          <a style="margin-right: 2px;" routerLink="/">Accueil</a> > Catalogue produits
          <span *ngFor="let cateLevel of categoriesLevelList">
            <span class="symbol">></span>
            <a style="margin-right: 2px;" *ngFor="let cate of cateLevel; index as i"
              [routerLink]="['/catalogues', cate?.codeCategory]">
              <span *ngIf="i !== 0 "> - </span>
              {{cate?.nameCategory['fr_FR']}}
            </a>
          </span>
        </div>
        <div *ngIf="checkRouterSupplier">
          <a style="margin-right: 2px;" routerLink="/">Accueil</a> > <a routerLink="/suppliers">Fournisseurs</a> >
          Catalogue Fournisseur : {{detailSupplier?.companyName}}
        </div>
        <div *ngIf="checkRouterRechercher">
          <a style="margin-right: 2px;" routerLink="/">Accueil</a> > Rechercher
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="list-products-page-inner pb-5">
      <h2 *ngIf="!checkListBySupplier && !checkRouterRechercher" class="title d-flex align-items-center gap-2">
        <img *ngIf="titleCategory" src="{{titleCategoryImage}}" alt="">
        {{titleCategory}}
      </h2>
      <h2 *ngIf="checkRouterRechercher" style="font-family: 'Poppins';"
        class="font-normal title d-flex align-items-center gap-2">
        Votre recherche pour : <span class="font-bold" style="font-family: 'Poppins-bold';">{{
          formFilter.value?.longDescription }}</span>
      </h2>
      <div *ngIf="checkListBySupplier" class="wrap-title-catalog-supplier d-flex align-items-center">
        <img *ngIf="detailSupplier?.logo" src="{{detailSupplier?.logo[0].url}}" alt="" />
        <img *ngIf="!detailSupplier?.logo" src="src-adisco/assets/images/image-default.jpeg" alt="" />
        <div>
          <h2 class="title mb-0">CATALOGUE FOURNISSEUR : <span>{{ detailSupplier?.companyName }}</span></h2>
          <div class="group-btn d-flex gap-1 align-items-center">
            <div
              *ngIf="userService.hasExtranetAccess('fonctions', 'export-fournisseurs-articles') || userService.hasExtranetAccess('fonctions', 'export-fournisseurs-tarifs')"
              class="position-relative wrap-btn-cata">
              <button (click)="toggleShow()" class="btn-common btn-catalogue">EXPORTER
              </button>
              <ul *ngIf="showListBtn" class="wrap-select-btn list-none">
                <li style="display: flex; flex-direction: row; align-items: center;gap: 4px;"
                  *ngIf="userService.hasExtranetAccess('fonctions', 'export-fournisseurs-articles')"
                  (click)=" !loadingExport.isExportProduct ? onExport('PRODUCT'): null"><span>Exporter les
                    articles</span><mat-spinner *ngIf="loadingExport.isExportProduct" [diameter]="15"></mat-spinner>
                </li>
                <li style="display: flex; flex-direction: row; align-items: center;gap: 4px;"
                  *ngIf="userService.hasExtranetAccess('fonctions', 'export-fournisseurs-tarifs')"
                  (click)="!loadingExport.isExportTariff ? onExport('PRICE') : null"><span>Exporter les tarifs</span>
                  <mat-spinner *ngIf="loadingExport.isExportTariff" [diameter]="15"></mat-spinner></li>
                <li style="border-top: 1px solid #4747474d; margin-top: 5px; padding-top: 5px;" *ngIf="progress > 0">
                  <p class="mb-1">({{progress}}%) En cours...</p>
                  <div class="progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" [ngStyle]="{ 'width': progress + '%' }"></div>
                  </div>
                </li>
              </ul>
            </div>
            <button routerLink="/suppliers/detail-supplier/{{detailSupplier?.code}}"
              class="btn-common btn-catalogue">VOIR LA
              FICHE</button>
          </div>
        </div>
      </div>
      <div class="main-content-list-products d-flex mb-5">
        <div #wrapFilter class="col-3 p-0 pr-3 wrap-filter">
          <div #wrapFilterInner [ngClass]="{'fixed': condition}" class="wrap-filter-inner">
            <p class="font-bold text-filter">FILTRES AJOUTÉS</p>

            <div class="group-tag d-flex align-items-center gap-2 flex-wrap">
              <div *ngIf="loadingIconStatus">
                <mat-spinner [diameter]="15"></mat-spinner>
              </div>
              <div *ngIf="!loadingIconStatus">
                <div *ngFor="let item of listIconFilter" class="tag d-flex align-items-center">{{ item?.value }}
                  <button (click)="delTag(item)" class="d-flex justify-content-center align-items-center gap-1">
                    <i class="pi pi-times"></i>
                  </button>
                </div>
              </div>
            </div>
            <button (click)="openDialog()" class="btn-common btn-modifier">MODIFIER</button>
            <button (click)="clearFilter()" class="btn-common btn-reset-filter">RÉINITIALISER LES
              FILTRES</button>


            <div class="form-filter-left">
              <ng-template [ngTemplateOutlet]="formFilterTemplate"></ng-template>
            </div>
          </div>
        </div>
        <div #wrapContent class="col-9 p-0 pl-3 group-product pt-3">
          <form [formGroup]="formPagination" class="">
            <div *ngIf="totalPages > 0" class="wrap-pagination">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="wrap-rows">
                  Afficher
                  <p-dropdown formControlName="rows" (onChange)="filterRows()" class="item-page"
                    [options]="listRows"></p-dropdown>éléments
                </div>
                <p-paginator *ngIf="totalPages > 1" #paginator1 (onPageChange)="onPageChange3($event)"
                  [ngClass]="{'show-dot': totalPages > 5 }" [rows]="rows3" [totalRecords]="totalRecords"
                  [showFirstLastIcon]="false" [showCurrentPageReport]="false"></p-paginator>
              </div>
            </div>
          </form>
          <ul class="list-none d-flex p-0 relative">
            <ng-container *ngFor="let item of listProduct">
              <li class="item" *ngIf="item?.uniqueId">
                <a (mouseover)="checkProductExitsCart($event,item)"
                  *ngIf="userService.hasExtranetAccess('fonctions', 'comparateur-produit')"
                  (click)="addProductToCompare(item?.id)" class="btn-comparer">
                  <img class="img-hover" src="src-adisco/assets/images/icon/comparator-white.svg" alt="">
                  <img class="img-default" src="src-adisco/assets/images/icon/comparator-blue.svg" alt="">
                </a>
                <a routerLink="/catalogues/product-detail/{{item?.uniqueId}}" class="item-inner">
                  <div class="wrap-img">
                    <img
                      src="{{item?.thumbnailPhoto?.[0]?.url ? item?.thumbnailPhoto?.[0]?.url : 'src-adisco/assets/images/image-default.jpeg'}}"
                      alt="">
                  </div>
                  <div class="wrap-info">
                    <p class="name font-bold">{{ item?.longDescription }}</p>
                    <p>Référence fournisseur : {{ item?.supplierItemNumber ? item?.supplierItemNumber : '-' }}</p>
                    <p>Référence Adisco : {{ item?.uniqueId ? item?.uniqueId : '-' }}</p>

                    <div class="status-container">
                      <p class="status">
                        Statut : <span class="font-bold">{{ item?.productOpenOrClosed?.value }}</span> </p>
                      <p *ngIf="item?.productplatform" class="platform font-bold">
                        Produit plateforme
                      </p>

                    </div>




                    <p>Fournisseur : {{ item?.nameSupplierText? item?.nameSupplierText : '-' }}</p>
                    <p>Marque : {{ item?.brand ? item?.brand : '-' }}</p>
                    <p>Dernière mise à jour : {{ item?.updatingDate ? (item?.updatingDate | date:'dd/MM/yyyy') : '-' }}
                    </p>
                    <p *ngIf="userService.hasExtranetAccess('fonctions', 'catalogue-tarifs')" class="price font-bold">
                      {{item?.pricelevelMaximum?.value | renamePriceLevel }} : {{ item?.maximumPrice ?
                      item?.maximumPrice.toFixed(2) : '-' }} € HT
                    </p>
                  </div>
                </a>
              </li>
            </ng-container>
            <div class="loading" *ngIf="loadingStatus">
              <img src="/src-adisco/assets/images/icon/loading.gif" alt="">
            </div>
          </ul>
          <form [formGroup]="formPagination" class="">
            <div *ngIf="totalPages > 0" class="wrap-pagination">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="wrap-rows">
                  Afficher
                  <p-dropdown formControlName="rows" (onChange)="filterRows()" class="item-page" [options]="listRows"
                    optionLabel=""></p-dropdown>éléments
                </div>
                <p-paginator *ngIf="totalPages > 1" #paginator2 (onPageChange)="onPageChange3($event)"
                  [ngClass]="{'show-dot': totalPages > 5 }" [rows]="rows3" [totalRecords]="totalRecords"
                  [showFirstLastIcon]="false" [showCurrentPageReport]="false"></p-paginator>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>


  <!-- Filters Dialog -->
  <p-dialog class="filter-dialog" [modal]="true" [(visible)]="visibleDialog" [style]="{ width: '80%' }">
    <div class="dialog-content">
      <div class="group-tag d-flex align-items-center gap-2 flex-wrap" style="height: fit-content;">
        <div *ngFor="let item of listIconFilter" class="tag d-flex align-items-center">{{ item?.value }}
          <button (click)="delTag(item)" class="d-flex justify-content-center align-items-center gap-1">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>

      <button (click)="saveDialog()" class="btn-common btn-valider">VALIDER</button>
      <div class="form-filter-dialog">
        <ng-template [ngTemplateOutlet]="formFilterTemplate"></ng-template>
      </div>

    </div>

  </p-dialog>
</div>

<ng-template #formFilterTemplate>
  <form [formGroup]="formFilter">

    <p-panel header="FILTRE PAR MOTS-CLÉS" [toggleable]="true" [collapsed]="true">
      <div class="wrap-input d-flex align-items-center justify-content-between gap-2 pb-2">
        <input [(ngModel)]="tempKeyworkSearch" [ngModelOptions]="{standalone: true}"
          (ngModelChange)="keyWorkSearchChange()" type="text" placeholder="Rechercher par mots-clés">

      </div>
    </p-panel>

    <!-- CATEGORIES PANEL -->

    <p-panel #panel header="CATÉGORIES" [toggleable]="true" [(collapsed)]="isCollapsed">

      <ng-template pTemplate="icons">

        <ng-container *ngIf="loadingCategory">
          <button pButton class="button-loading">
            <mat-spinner [diameter]="15"></mat-spinner>
          </button>
        </ng-container>
      </ng-template>


      <div class="wrap-categories">

        <div class="level"
          [ngClass]="{'selected' : formFilter.value?.categoryProduct ? formFilter.value?.categoryProduct === category.codeCategory : category.codeCategory=== idCategory}"
          *ngFor="let category of transformedArray" (click)="clickLevel1Category($event, category)">

          <p-panel class="lv-1 panel-cate" header="{{category.nameCategory.fr_FR}}" [toggleable]="true"
            [collapsed]="true">
            <div class="wrap-categories">
              <div class="level"
                [ngClass]="{'selected' : formFilter.value?.categoryProduct ? formFilter.value?.categoryProduct === subcategory.codeCategory : subcategory.codeCategory=== idCategory}"
                *ngFor="let subcategory of category.subcategoryList"
                (click)="getProductOfCategoryLevel2($event, subcategory.codeCategory, category, subcategory)">
                <p-panel class="panel-cate" header=" {{subcategory.nameCategory.fr_FR}}" [toggleable]="true"
                  [collapsed]="true">
                  <div class="wrap-categories">
                    <div class="level" *ngFor="let subcategory3 of subcategory.subcategoryList"
                      (click)="getProductOfCategoryLevel3($event, subcategory3.codeCategory, category, subcategory3)">

                      <div>
                        <a class="d-block lv-2"
                          [ngClass]="{'selected' : formFilter.value?.categoryProduct ? formFilter.value?.categoryProduct === subcategory3.codeCategory : subcategory3.codeCategory=== idCategory}">{{subcategory3.nameCategory.fr_FR}}</a>
                      </div>

                    </div>
                  </div>
                </p-panel>
              </div>
            </div>
          </p-panel>
        </div>

      </div>
    </p-panel>
    <!-- FOURNISSEUR PANEL -->

    <p-panel *ngIf="!isSupplierCatalog && (checkRouterCategories || checkRouterRechercher)" header="FOURNISSEUR"
      [toggleable]="true" [collapsed]="true">
      <div class="wrap-select pb-2">
        <p-multiSelect formControlName="fournisseur" [options]="listSuppliers" optionLabel="companyName"
          optionValue="code" placeholder="Choisissez un ou des fournisseurs"></p-multiSelect>
      </div>
    </p-panel>
    <p-panel header="MARQUE" [toggleable]="true" [collapsed]="true">
      <div class="wrap-input d-flex align-items-center justify-content-between gap-2 pb-2">
        <input formControlName="brand" type="text" placeholder="Rechercher une marque">
      </div>
    </p-panel>
    <p-panel header="PAYS DE FABRICATION" [toggleable]="true" [collapsed]="true">
      <div class="wrap-input d-flex align-items-center justify-content-between gap-2 pb-2">
        <p-dropdown formControlName="countryOfManufacture" class="w-12" [options]="listCountry" optionLabel="label"
          optionValue="valeur" placeholder="Choisissez pays"></p-dropdown>
      </div>
    </p-panel>
    <p-panel header="DÉVELOPPEMENT DURABLE" [toggleable]="true" [collapsed]="true">
      <div class="wrap-input d-flex align-items-center justify-content-between gap-2 pb-2">
        <p-multiSelect formControlName="developpementDurable" [options]="listSustainableDevelopment" [filter]="false"
          optionLabel="label" placeholder="Choisissez un label"></p-multiSelect>
      </div>
    </p-panel>

    <p-panel header="AUTRES INFORMATIONS" [toggleable]="true" [collapsed]="true">
      <div class="wrap-input d-flex align-items-center justify-content-between gap-2 pb-2">
        <p-multiSelect formControlName="autresInformations" [options]="listAutresInformations" [filter]="false"
          optionLabel="label" placeholder="Choisissez un critère"></p-multiSelect>
      </div>

    </p-panel>
    <p-panel header="STATUT" [toggleable]="true" [collapsed]="true">
      <div class="wrap-input pb-2 mb-3">
        <div class="flex align-items-center gap-1 mb-2">
          <p-checkbox [formControl]="ouvertControl" value="OUVERT" inputId="ouvert"
            (onChange)="toggleStatus('OUVERT', $event)"></p-checkbox>
          <label class="mb-0" for="ouvert">Ouvert</label>
        </div>
        <div class="flex align-items-center gap-1">
          <p-checkbox [formControl]="femeControl" value="FERMÉ" inputId="ferme"
            (onChange)="toggleStatus('FERMÉ', $event)"></p-checkbox>
          <label class="mb-0" for="ferme">Fermé</label>
        </div>
      </div>
    </p-panel>
  </form>
</ng-template>

<ng-container *ngIf="loadingProductList && !shouldShowSpinner">
  <div class="overlay-loading">
    <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="5" fill="var(--surface-ground)"
      animationDuration="1s"></p-progressSpinner>
  </div>
</ng-container>